export const getFilterBarStyles = (_, { palette = {} }) => ({
  FilterBar: {
    position: 'relative',
    minHeight: '56px',
    display: 'flex',
    backgroundColor: palette.neutralLighter,
    '& .filter-bar-filter-text': {
      fontWeight: '600',
      fontSize: '14px',
      color: palette.neutralPrimary,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: '150px',
      paddingRight: '12px',
    },
    '& .filter-bar-button-group': {
      marginLeft: 'auto',
      display: 'flex',
    },
    '& .save-filter-button': {
      border: 'none',
    },
    '& .filter-bar-ignore-click-outside ul.is-open i[data-icon-name="ChevronRight"]': {
      color: palette.neutralSecondary,
    },
    '& button.add-filter-button .iconba-Add': {
      color: palette.neutralSecondary,
    },
    '& button.filter-bar-button': {
      border: 'none',
      background: 'transparent',
      padding: '0px 7px',
      height: 56,
      '& .iconba': {
        color: palette.neutralSecondary,
      },
      '&:hover': {
        backgroundColor: palette.neutralLight,
      },
      '&:focus': {
        backgroundColor: palette.neutralQuaternaryAlt,
        '&:hover': {
          backgroundColor: palette.neutralQuaternary,
        },
      },
    },
    '& .filter-bar-divider': {
      borderLeft: `1px solid ${palette.neutralLight}`,
      margin: '8px 0px',
    },
    '& button.filter-bar-cancel-button': {
      padding: '0px 18px',
      minWidth: 'auto',
      '& .iconba:before': {
        color: palette.neutralSecondary,
      },
    },
    '& div[role=alert]': {
      color: palette.redDark,
    },
  },
  SaveFilterPopover: {
    '& .popover-content': {
      padding: '0px 16px 16px 16px',
    },
    marginTop: '1px !important',
    '& .arrow': {
      display: 'none !important',
    },
    '& .popover-title': {
      display: 'none !important',
    },
    '& .save-filter-title .control-label': {
      fontSize: '20px',
      paddingTop: '24px',
    },
    '& div[role=alert]': {
      color: palette.redDark,
    },
  },
});
